export default __webpack_public_path__ + "static/media/Link3.36817bb8.svg";